import { render, staticRenderFns } from "./FolderFilesComponent.vue?vue&type=template&id=049fe6c6&"
import script from "./FolderFilesComponent.vue?vue&type=script&lang=js&"
export * from "./FolderFilesComponent.vue?vue&type=script&lang=js&"
import style0 from "./FolderFilesComponent.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports